<script>
export default {
	props: ['order', 'checkout'],
}
</script>

<template>
	<GoCuotasCardContent />
</template>
